import { OnsiteInterviewAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { IGetOnsiteInterviewListPayload } from '../types';
import { IGetOnsiteInterviewListResult } from '../types/OnsiteInterview';

export const getOnsiteInterviewList = async (
  payload: IGetOnsiteInterviewListPayload,
): Promise<IGetOnsiteInterviewListResult> => {
  const response = await PermanentJobsApi.getOnsiteInterviewList(payload);

  return OnsiteInterviewAdapters.toGetOnsiteInterviewListResult(response);
};
